export type Users = any;
export type User = {
  AccountName: string;
  DirectReports: string[];
  DisplayName: string;
  Id: number;
  Email: string;
  ExtendedManagers: { results?: string[] };
  ExtendedReports: { results?: string[] };
  IsFollowed: boolean;
  LatestPost: string;
  Peers: { results?: string[] };
  PersonalSiteHostUrl: string;
  PersonalUrl: string;
  PictureUrl: string;
  PreferredName: string;
  Title: null | string;
  UserProfileProperties: any[];
  UserUrl: string;
  Groups: { Id: number }[];
  Roles: { ID: number; Role: string; Collection: { ID: number }; LocationMyTasks: { ID: number } }[];
  Partners: [];
  PartnersData: {
    Id: number;
    PartnerKey: string;
    Title: string;
    WarehousesPartner: {
      results: {
        Title: string;
      }[];
    };
  };
  aiEnabled: boolean;
  __metadata: object;
};
export type Response = User;
export interface CurrentUserState {
  readonly status: Status;
  readonly current: User;
}
export type SelectedCurrentUser =
  | {
    jobTitle: string;
    accountName: string;
    displayName: string;
    email: string | null;
    id: number;
    shortName: string;
    avatar: string | null;
  }
  | undefined;

export const initialCurrentState: CurrentUserState = {
  status: "IDLE",
  current: {
    PreferredName: "",
    Roles: [],
    AccountName: "",
    DirectReports: [],
    DisplayName: "",
    Email: "",
    ExtendedManagers: {},
    ExtendedReports: {},
    IsFollowed: false,
    LatestPost: "",
    Peers: {},
    Id: 0,
    PersonalSiteHostUrl: "",
    PersonalUrl: "",
    PictureUrl: "",
    Title: null,
    UserProfileProperties: [],
    UserUrl: "",
    Groups: [],
    Partners: [],
    PartnersData: {
      Id: 0,
      PartnerKey: "",
      Title: "",
      WarehousesPartner: {
        results: [],
      },
    },
    __metadata: {},
  },
};
export type Status = "LOADING" | "SUCCESS" | "IDLE" | "FAILURE";

export interface UsersState {
  readonly status: Status;
  readonly data: any;
}
export type SelectedUsers = any;

export const initialState: UsersState = {
  status: "IDLE",
  data: {},
};

export type UserReturnType = {
  displayName: string;
  fullName: string;
  email: string;
  originalEmail: string;
  avatar: string;
  accountName: string;
  shortName: string;
  manager: string;
  persNumber: string;
  jobTitle: string;
  jobTitleStr: string;
  department: string;
};
export type CurrentUserType = {
  accountName: string;
  displayName: string;
  fullName: string;
  fullNameWithPatronymic: string;
  email: string;
  originalEmail: string | null;
  id: number;
  avatar: string;
  shortName: string;
  persNumber: string;
  isAdmin: boolean;
  isSecurityAdmin: boolean;
  isSecurityEditor: boolean;
  groups: Array<{ Id: number }>;
  jobTitle: string;
  jobTitleStr: string;
  department: string;
  peers: { results?: string[] };
  managers: { results?: string[] };
  reports: string[];
  isDirecor: boolean; // Примечание: опечатка в оригинале (должно быть isDirector)
  isFactoryAdmin: boolean;
  hasFactoryAdminRole: boolean;
  isLocationEditorMyTasks: number[] | boolean;
  isLocationAdminMyTasks: number[] | boolean;
  isCollectionEditor: number[] | boolean;
  isCollectionAdmin: number[] | boolean;
  infoVPO: any;
  infoGOS: any;
  isVisit?: boolean; // Добавляется через addAnalysis
};
